export default "__VITE_ASSET__CdwY39DX__"